import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"
import _imports_0 from '../../assets/images/company-circle.png'


const _hoisted_1 = { class: "profile-main-container" }
const _hoisted_2 = { class: "profile-brand" }
const _hoisted_3 = { class: "profile-avatar-container" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "dialog-bubble" }
const _hoisted_6 = { class: "dialog-bubble-content" }
const _hoisted_7 = { class: "dialog-header" }
const _hoisted_8 = { class: "text-h5" }
const _hoisted_9 = { class: "dialog-main" }
const _hoisted_10 = { class: "profile-avatar-container" }
const _hoisted_11 = { class: "avatar" }
const _hoisted_12 = { class: "avatar-info" }
const _hoisted_13 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_header = _resolveComponent("q-header")!

  return (_openBlock(), _createBlock(_component_q_header, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_q_img, {
            src: _ctx.brandImage,
            "error-src": _ctx.fallbackBrandImage,
            alt: "Brand image",
            class: "brand-image"
          }, null, 8, ["src", "error-src"])
        ]),
        _cache[4] || (_cache[4] = _createElementVNode("img", {
          src: _imports_0,
          class: "profile-company-circle"
        }, null, -1)),
        _createElementVNode("div", {
          class: "profile-container",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dialogToggle()))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_q_img, {
                src: _ctx.profileImage,
                "error-src": _ctx.fallbackProfileImage,
                class: "avatar-image",
                style: {"border-radius":"50%","object-fit":"cover","width":"100%","height":"100%","border":"2px solid white"}
              }, null, 8, ["src", "error-src"]),
              _cache[3] || (_cache[3] = _createElementVNode("span", { class: "material-icons" }, " arrow_drop_down ", -1))
            ])
          ])
        ])
      ]),
      (_ctx.profileDialog)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "dialog-container",
            onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dialogToggle()))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "material-icons" }, " arrow_drop_up ", -1)),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("myProfile.definition")), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_q_img, {
                        src: _ctx.profileImage,
                        "error-src": _ctx.fallbackProfileImage,
                        class: "avatar-image",
                        style: {"border-radius":"50%","object-fit":"cover","width":"100%","height":"100%","border":"1px solid white"}
                      }, null, 8, ["src", "error-src"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_ctx.userName) + " ", 1),
                      _createElementVNode("sub", null, _toDisplayString(_ctx.userEmail), 1)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.viewRbac)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        class: "btn btn-dialog-footer text-body2",
                        label: _ctx.$t('settingsBtn.definition'),
                        to: "/account/account/"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_btn, {
                    class: "btn btn-dialog-footer margin-left-190 text-body2",
                    label: _ctx.$t('signOut.definition'),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logOut()))
                  }, null, 8, ["label"])
                ])
              ])
            ])
          ], 32))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}